import type { FormatEditorConfig } from "./types";

export const latexConfig: FormatEditorConfig = {
  language: "latex",
};
